import { useAccountAssets } from "../../logic/hooks/useAccountAssets.js";
import { useAccountCommands } from "../../logic/hooks/useAccountCommands.js";
import { AssetManager } from "./AssetManager.jsx";

export function AccountAssetsTab({ account }) {
  const assetState = useAccountAssets(account.id);
  const commandState = useAccountCommands(account.id);

  return (
    <AssetManager
      {...assetState}
      commandState={commandState}
      emptyHint={`Add assets for ${account.companyName} using the schemas defined in Asset types.`}
    />
  );
}
